import React from "react";

const svgBase = {
  className: "league-share-menu-item-svg",
  width: 22,
  height: 22,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

export function ShareMenuIconDevice() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 4v9M9 8l3-4 3 4"
        stroke="#475569"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="13" width="16" height="8" rx="2" stroke="#475569" strokeWidth="1.75" />
    </svg>
  );
}

export function ShareMenuIconCopy() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24" fill="none">
      <path
        stroke="#475569"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 8V6a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 01-2 2h-2M8 8a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
      />
    </svg>
  );
}

export function ShareMenuIconX() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24">
      <path
        fill="#000000"
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
      />
    </svg>
  );
}

export function ShareMenuIconFacebook() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24">
      <path
        fill="#1877F2"
        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
      />
    </svg>
  );
}

export function ShareMenuIconLinkedIn() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24">
      <path
        fill="#0A66C2"
        d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
      />
    </svg>
  );
}

export function ShareMenuIconWhatsApp() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24">
      <path
        fill="#25D366"
        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.883 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
      />
    </svg>
  );
}

export function ShareMenuIconTelegram() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24">
      <path
        fill="#26A5E4"
        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.181 2.088-.957 7.098-1.352 9.394-.169.957-.517 1.276-.849 1.307-.734.069-1.292-.489-2.009-.958-1.112-.735-1.741-1.192-2.817-1.912-1.249-.834-.442-1.292.274-2.036.171-.169 3.086-2.849 3.154-3.091.009-.036.019-.173-.069-.266-.086-.086-.217-.068-.319-.049-.146.036-2.459 1.579-7.049 5.069-.667.489-1.271.727-1.821.714-.596-.027-1.742-.394-2.596-.727-1.048-.394-1.881-.604-1.809-1.276.038-.355.579-.734 1.598-1.133 6.297-2.849 11.069-5.069 13.069-7.069 1.568-1.568 2.269-2.568 2.568-2.568.234-.012.517.055.609.299.051.129.061.299.041.454z"
      />
    </svg>
  );
}

export function ShareMenuIconReddit() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24">
      <circle cx="12" cy="13.25" r="10.75" fill="#FF4500" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M17.6 12.3a1 1 0 00-1.7-.71l-1.62 1.62a4.9 4.9 0 00-4.56 0L8.1 11.59a1 1 0 10-1 1.7l1 1a4.94 4.94 0 00-.16 1.18c0 2.22 1.99 4.03 4.45 4.03s4.45-1.8 4.45-4.03c0-.4-.07-.8-.2-1.18l1.05-1zM9.6 15c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4.85 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
      />
      <circle cx="17.5" cy="6.5" r="2.5" fill="#fff" />
      <path fill="none" stroke="#FF4500" strokeLinecap="round" strokeWidth="1.3" d="M15.75 6.5l-2.5-.6" />
    </svg>
  );
}

export function ShareMenuIconEmail() {
  return (
    <svg {...svgBase} viewBox="0 0 24 24" fill="none">
      <path
        stroke="#475569"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 7h16v10H4V7zm0 0l8 7 8-7"
      />
    </svg>
  );
}
